export default __webpack_public_path__ + "static/media/6.3f1d420f.jpg";